import qs from 'qs';

import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';

import { redirectToMain } from '../lib';

const baseQuery = (baseUrl: string) =>
  fetchBaseQuery({
    baseUrl,
    headers: {
      Accept: 'application/json',
    },
    credentials: 'same-origin',
    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
    prepareHeaders: (headers) => {
      if (localStorage.getItem('token')) {
        headers.set('Authorization', `Bearer ${localStorage.getItem('token')}`);
      }

      return headers;
    },
  });

const baseQueryWithLogout: (
  baseUrl: string
) => BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =
  (baseUrl: string) => async (args, api, extraOptions) => {
    const result = await baseQuery(baseUrl)(args, api, extraOptions);

    if (
      result.error &&
      result.error.status === 401 &&
      localStorage.getItem('token')
    )
      redirectToMain();

    return result;
  };

export const createApiFor = (reducerPath: string, baseUrl: string) => {
  return createApi({
    reducerPath,
    baseQuery: baseQueryWithLogout(baseUrl),
    tagTypes: [
      'Sites',
      'SitesV3',
      'AdUnits',
      'User',
      'Orders',
      'PaymentMethods',
      'Statistics',
      'AdsTxt',
      'VideoEditorConfig',
      'ContentList',
      'ContentStylesList',
      'Referrals',
      'ReferralSites',
    ],
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    endpoints: (_) => ({}),
  });
};

export type BaseApi = ReturnType<typeof createApiFor>;
